import { Wrench, Clock } from "lucide-react";
import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../lib/firebase";

export default function Maintenance() {
  const [message, setMessage] = useState("ขณะนี้ระบบ EduMi อยู่ระหว่างปรับปรุงชั่วคราว\nทีมงานกำลังอัปเดตระบบ กรุณากลับมาใหม่อีกครั้ง");

  useEffect(() => {
    document.title = "ระบบปรับปรุง - EduMi LMS";
    
    const metaRobots = document.querySelector('meta[name="robots"]');
    if (metaRobots) {
      metaRobots.setAttribute('content', 'noindex, nofollow');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'robots';
      meta.content = 'noindex, nofollow';
      document.head.appendChild(meta);
    }

    const loadMessage = async () => {
      try {
        const docRef = doc(db, "systemSettings", "general");
        const docSnap = await getDoc(docRef);
        
        if (docSnap.exists()) {
          const data = docSnap.data();
          if (data.maintenance?.message) {
            setMessage(data.maintenance.message);
          }
        }
      } catch (error) {
        console.error("Error loading maintenance message:", error);
      }
    };

    loadMessage();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-blue-50 to-indigo-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-2xl p-8 text-center">
        <div className="flex justify-center mb-6">
          <div className="bg-blue-100 p-5 rounded-full animate-pulse">
            <Wrench className="w-16 h-16 text-blue-600" />
          </div>
        </div>
        
        <div className="text-gray-900 mb-6 text-lg whitespace-pre-line">
          {message}
        </div>
        
        <div className="bg-blue-50 rounded-xl p-5 mb-6">
          <div className="flex items-center justify-center gap-2 mb-2">
            <Clock className="w-5 h-5 text-blue-600" />
            <p className="text-sm font-semibold text-blue-800">
              ระยะเวลาโดยประมาณ
            </p>
          </div>
          <p className="text-sm text-blue-700">
            ขออภัยในความไม่สะดวก เราจะกลับมาให้บริการโดยเร็วที่สุด
          </p>
        </div>

        <div className="flex justify-center">
          <img 
            src="/logo.png" 
            alt="EduMi Logo" 
            className="h-12 opacity-50"
          />
        </div>
      </div>
    </div>
  );
}
